import { render, staticRenderFns } from "./CategoriasView.vue?vue&type=template&id=d00899f2&scoped=true&"
import script from "./CategoriasView.vue?vue&type=script&lang=js&"
export * from "./CategoriasView.vue?vue&type=script&lang=js&"
import style0 from "./CategoriasView.vue?vue&type=style&index=0&id=d00899f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00899f2",
  null
  
)

export default component.exports